import type { MouseEvent, ReactNode } from 'react'

/**
 * A hardcoded crash page with absolutely zero dependencies on React context.
 * This is the last resort fallback when the normal error boundary fails to render.
 *
 * DO NOT add any hooks, context consumers, or imports from libraries that use context.
 * This component must be able to render even when React's internal state is inconsistent.
 */

// Module-level guard: no hooks allowed in this component.
// Prevents rage-clicking the mailto link from opening dozens of compose windows.
let supportEmailCooldownActive = false

export function HardcodedFallbackCrashPage(): ReactNode {
  const handleSupportEmailClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (supportEmailCooldownActive) {
      e.preventDefault()
      return
    }
    supportEmailCooldownActive = true
    setTimeout(() => {
      supportEmailCooldownActive = false
    }, 1500)
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '40px',
        textAlign: 'center',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
    >
      <h1 style={{ fontSize: '24px', marginBottom: '16px' }}>Oups, une erreur s’est produite</h1>
      <p style={{ fontSize: '16px', color: '#666', marginBottom: '24px' }}>
        Veuillez rafraîchir la page. Si le problème persiste, contactez notre support.
      </p>
      <div style={{ display: 'flex', gap: '16px' }}>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '12px 24px',
            fontSize: '16px',
            backgroundColor: '#000',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
          }}
        >
          Rafraîchir la page
        </button>
        <a
          href="mailto:support@orus.eu"
          onClick={handleSupportEmailClick}
          style={{
            padding: '12px 24px',
            fontSize: '16px',
            backgroundColor: '#fff',
            color: '#000',
            border: '1px solid #000',
            borderRadius: '8px',
            textDecoration: 'none',
          }}
        >
          Contacter le support
        </a>
      </div>
    </div>
  )
}
